export default {
  messageType: '기본형',
  label: {
    imageLink: '이미지 링크',
    image: '이미지 첨부',
  },
  placeholder: {
    imageLink: 'http://',
    content: '메시지 내용을 입력해 주세요.',
    brandTextContent: '1,300자',
    textContent: '1,000자',
    imageContent: '400자',
    wideImageContent: '76자',
  },
  comment: {
    image: '※ 기본형 또는 와이드 이미지형으로 발송됩니다.',
    imageLink: '※ 첨부한 이미지 탭(클릭) 시, 연결할 페이지 주소를 입력해 주세요',
  },
  preview: {
    header: '광고',
    footer: '수신거부 : 홈 > 친구차단',
    content: '내용을 입력해주세요.',
    title: '제목을 입력해주세요.',
    productName: '상품명을 입력해주세요.',
    regularPrice: '정상가격',
    discountPrice: '할인가격',
    discountRate: '할인율',
    discountFixed: '정액할인가격',
    KRW: '원',
    additionalContent: '부가 정보를 입력해주세요.',
    intro: '캐러셀 인트로 설정을 사용하시면 활성화됩니다.',
    introTitle: '인트로 제목을 입력해주세요.',
    introContent: '인트로 내용을 입력해주세요.',
    tail: '더보기',
  },
};
